import { html, TemplateResult } from 'lit';
import { msg } from '@lit/localize';
import { unsafeHTML } from 'lit/directives/unsafe-html.js';
import type { RoundtripStageContent } from '../types/roundtrip-stage-content.types.js';

export const renderRichText = (content: RoundtripStageContent): TemplateResult => {
    if (!content.richText) {
        return html``;
    }

    return html`
        <div class="der-tm-roundtrip-stage__rich-text">
            <div class="der-tm-roundtrip-stage__rich-text-title">
                ${msg('Highlights der Rundreise', { desc: 'Roundtrip highlights section title' })}
            </div>
            ${unsafeHTML(content.richText)}
        </div>
    `;
};
